import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getCarListings = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/car_listings?' + params.toString()); // Let the error bubble up
};

const getCarListingById = async (id: number) => {
  return await apiClient.get(`/car_listings/${id}`); // Fetch car listing by ID
};

const createCarListing = async (carListingData: any) => {
  return await apiClient.post('/car_listings', carListingData); // Create a new car listing
};

const updateCarListing = async (id: number, carListingData: any) => {
  return await apiClient.patch(`/car_listings/${id}`, carListingData); // Update car listing by ID
};

const deleteCarListing = async (id: number) => {
  return await apiClient.delete(`/car_listings/${id}`); // Delete car listing by ID
};

export default {
  getCarListings,
  getCarListingById,
  createCarListing,
  updateCarListing,
  deleteCarListing,
};
